import React, {Component} from 'react';
import {withApplicationContext} from "../../../contexts/ApplicationContext"
import {withGameTableContext} from "../../../contexts/GameTableContext"
class TableRow extends Component {
    constructor(props) {
        super(props);
        this.state = {

        }

    }

    render() {
        const {children, key} = this.props;
        return (
            <tr key={key}>
                {children}
            </tr>
        );
    }
}

export default withApplicationContext(withGameTableContext(TableRow));